export default __webpack_public_path__ + "static/media/x-blueAssetWallet.96281ad5.svg";